module.exports = __webpack_public_path__ + "img/4d9ddd2.jpg";